import { em } from 'polished'
import styled from 'styled-components'

import { H2, Text } from 'styles/components/typography'

export const TextStyled = styled(Text)`
  text-align: center;
  margin: ${em(20)};

  ${p => p.theme.mq.upMd} {
    margin: ${em(60)} 0;
  }
`

export const H2Styled = styled(H2)`
  text-align: center;
  margin-top: ${em(20)};
  margin-bottom: ${em(20)};

  ${p => p.theme.mq.upMd} {
    margin-top: ${em(30)};
    margin-bottom: ${em(30)};
  }
`
